import { getDataAPI, postDataAPI } from "../../services/apiWrapper";

/*
  NOC, public website.

  A visitor identifies the student with their roll/enrollment number and date of
  birth, then applies exactly as the student would. No login token - the public
  NOC routes are open, and the date of birth is re-checked on the server.
*/

export const getNocTypes = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("noc/types"));
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const verifyStudent = (body) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("noc/verify", body));
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "Could not verify the student.",
      }
    );
  }
};

export const applyNoc = (body) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("noc/apply", body));
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "The request could not be sent. Please try again.",
      }
    );
  }
};

export const payNocSuccess = (body) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("noc/pay-success", body));
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failed",
        message: "Payment could not be verified.",
      }
    );
  }
};
